import { COPYRIGHT_DISCLAIMER } from "../lib/content";

export function Footer() {
  return (
    <footer className="no-print border-t border-[#E2E8F0] bg-[#F1F5F9] px-6 py-6 sm:px-10" data-testid="site-footer">
      <p className="mx-auto max-w-5xl text-center text-xs leading-relaxed text-[#1E293B]/50">
        {COPYRIGHT_DISCLAIMER}
      </p>
    </footer>
  );
}
